import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.117 30A4.116 4 0 0 0 20 34a4.116 4 0 0 0 4.117 4h51.766A4.116 4 0 0 0 80 34a4.116 4 0 0 0-4.117-4zm-.002 16A4.116 4 0 0 0 20 50a4.116 4 0 0 0 4.115 4h51.77A4.116 4 0 0 0 80 50a4.116 4 0 0 0-4.115-4zm.002 16A4.116 4.001 0 0 0 20 66a4.116 4.001 0 0 0 4.117 4h51.766A4.116 4.001 0 0 0 80 66a4.116 4.001 0 0 0-4.117-4z" })
});
export default SvgMenu;
